import { z } from 'zod'

const stringBooleanSchema = z
  .string()
  .refine((value) => ['true', 'false'].includes(value.toLowerCase()))
  .transform((value) => value.toLowerCase() === 'true')

export const commonSearchParamsSchema = z
  .object({
    hideHeader: stringBooleanSchema,
    hideEversportsBranding: stringBooleanSchema,
    companyId: z.string().uuid(),
  })
  .partial()
